/* PVZOD Atelier. Native Shopify checkout; local-currency data stays in Shopify's context. */
(() => {
  'use strict';
  const configNode = document.getElementById('AtelierConfig');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = (config.root || '/').replace(/\/?$/, '/');
  const strings = config.strings;
  const live = document.getElementById('LiveRegion');
  const announce = message => { if (live) live.textContent = message; };
  const money = cents => new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'EUR' }).format(cents / 100);
  const openers = new Map();
  function openDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    document.querySelectorAll('dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
    if (trigger) openers.set(id, trigger);
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('dialog-open');
    if (id === 'SearchDialog') dialog.querySelector('input[type="search"]')?.focus();
    return true;
  }
  function wireDialog(dialog) {
    if (dialog.dataset.wired) return;
    dialog.dataset.wired = 'true';
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('dialog-open');
      const trigger = openers.get(dialog.id);
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
      openers.delete(dialog.id);
    });
    dialog.addEventListener('click', event => {
      const bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
    });
  }
  document.querySelectorAll('dialog').forEach(wireDialog);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open]');
    if (trigger && openDialog(trigger.dataset.open, trigger)) event.preventDefault();
    if (event.target.closest('[data-close]')) event.target.closest('dialog')?.close();
    document.querySelectorAll('.nav-dropdown[open],.filter-group[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.nav-dropdown[open],.filter-group[open]').forEach(details => details.open = false); });
  let cartBusy = false;
  function cartError(message) {
    const target = document.querySelector('[data-cart-error]');
    if (target) target.textContent = message;
    announce(message);
  }
  function replaceDrawer(html) {
    if (!html) return false;
    const fragment = new DOMParser().parseFromString(html, 'text/html');
    const fresh = fragment.getElementById('CartDrawer');
    const current = document.getElementById('CartDrawer');
    if (!fresh || !current) return false;
    // Keep the original dialog node, focus trap, and close handler intact.
    current.innerHTML = fresh.innerHTML;
    return true;
  }
  async function syncCart(data) {
    let rendered = replaceDrawer(data.sections?.['cart-drawer']);
    if (!rendered) {
      try {
        const response = await fetch(`${root}?section_id=cart-drawer`, { headers: { Accept: 'text/html' } });
        if (response.ok) rendered = replaceDrawer(await response.text());
      } catch (_) { /* Successful add must never be retried because rendering failed. */ }
    }
    if (!rendered) { window.location.assign(config.cartUrl || `${root}cart`); return false; }
    let count = data.item_count;
    if (typeof count !== 'number') {
      try { const response = await fetch(`${root}cart.js`); if (response.ok) count = (await response.json()).item_count; } catch (_) {}
    }
    if (typeof count === 'number') document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = count);
    return true;
  }
  async function cartRequest(path, body) {
    const response = await fetch(`${root}cart/${path}.js`, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ ...body, sections: ['cart-drawer'], sections_url: root }) });
    const payload = await response.json();
    if (!response.ok || payload.status >= 400) throw new Error(payload.description || payload.message || strings.error);
    return payload;
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-ajax-add]');
    if (!form) return;
    if (!window.fetch || typeof HTMLDialogElement === 'undefined') return;
    event.preventDefault();
    if (cartBusy) return;
    const input = new FormData(form);
    const variantId = input.get('id');
    if (!variantId) return;
    const button = form.querySelector('[type="submit"]');
    const label = button?.querySelector('[data-add-label]');
    const error = form.querySelector('.form-error');
    const original = label?.textContent;
    cartBusy = true;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    if (label) label.textContent = strings.adding;
    if (error) error.textContent = '';
    const item = { id: variantId, quantity: Number(input.get('quantity') || 1) };
    const properties = {};
    input.forEach((value, key) => { const match = key.match(/^properties\[(.+)\]$/); if (match && typeof value === 'string') properties[match[1]] = value; });
    if (Object.keys(properties).length) item.properties = properties;
    if (input.get('selling_plan')) item.selling_plan = input.get('selling_plan');
    try {
      const payload = await cartRequest('add', { items: [item] });
      if (await syncCart(payload)) { openDialog('CartDrawer', button); announce(strings.added); }
    } catch (errorObject) { if (error) error.textContent = errorObject.message || strings.error; announce(errorObject.message || strings.error); }
    finally { cartBusy = false; if (button) { button.disabled = false; button.removeAttribute('aria-busy'); } if (label) label.textContent = original; form.closest('[data-product-section]')?.dispatchEvent(new CustomEvent('atelier:variant-refresh', { detail: { keepError: true } })); }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-change]');
    if (!button || cartBusy) return;
    cartBusy = true;
    const drawer = document.getElementById('CartDrawer');
    const oldKey = button.dataset.cartChange;
    const oldQuantity = button.dataset.quantity;
    drawer?.querySelectorAll('[data-cart-change]').forEach(node => node.disabled = true);
    cartError('');
    try {
      const payload = await cartRequest('change', { id: oldKey, quantity: Number(oldQuantity) });
      await syncCart(payload);
      const replacement = Array.from(drawer?.querySelectorAll('[data-cart-change]') || []).find(node => node.dataset.cartChange === oldKey && node.dataset.quantity === oldQuantity);
      (replacement || drawer?.querySelector('[data-close]'))?.focus({ preventScroll: true });
    } catch (error) { cartError(error.message || strings.error); }
    finally { cartBusy = false; drawer?.querySelectorAll('[data-cart-change]').forEach(node => node.disabled = false); }
  });
  function initializeProducts(scope = document) {
    const state = globalThis.PVZODVariantState;
    if (!state) return; // Leave the native variant select usable if enhancement cannot load.
    const sections = [...scope.querySelectorAll('[data-product-section]')];
    if (scope.matches?.('[data-product-section]')) sections.unshift(scope);
    sections.forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const variants = JSON.parse(section.querySelector('[data-variants]').textContent);
      const selector = section.querySelector('[data-variant-id]');
      const options = section.querySelector('.js-variant-options');
      const form = section.querySelector('.product-form');
      if (!selector || !form) return;
      const groups = options ? [...options.querySelectorAll('[data-option-group]')].sort((a,b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)) : [];
      const colorIndexes = groups.filter(group => group.dataset.optionKind === 'color').map(group => Number(group.dataset.optionIndex));
      let customPalette = '';
      try { customPalette = JSON.parse(section.querySelector('[data-swatch-map]')?.textContent || '""'); } catch (_) {}
      const palette = state.parsePalette(customPalette);
      section.querySelectorAll('[data-color-name]').forEach(disc => {
        if (disc.querySelector('img')) return;
        const name = state.normalize(disc.dataset.colorName);
        const candidate = disc.dataset.nativeColor || palette[name] || name;
        if (CSS.supports('color', candidate)) { disc.style.background = candidate; disc.dataset.resolved = 'true'; }
      });
      const initialVariant = variants.find(variant => String(variant.id) === selector.value);
      groups.forEach((group,index) => {
        const initialValue = initialVariant?.options[index];
        if (initialValue == null) return;
        const select = group.querySelector('select');
        if (select) select.value = initialValue;
        else group.querySelectorAll('input[type="radio"]').forEach(input => input.checked = input.value === initialValue);
      });
      if (options) { options.hidden = false; section.querySelector('.variant-fallback').hidden = true; }
      else section.querySelector('.variant-fallback').hidden = true;
      const mediaNodes = [...section.querySelectorAll('.gallery-stage [data-media-id]')];
      const defaultMediaId = mediaNodes[0]?.dataset.mediaId;
      function activateMedia(id) {
        if (!mediaNodes.length) return;
        const chosen = mediaNodes.find(node => String(node.dataset.mediaId) === String(id)) || mediaNodes[0];
        mediaNodes.forEach(node => { node.hidden = node !== chosen; if (node !== chosen) node.querySelectorAll('video').forEach(video => video.pause()); });
        section.querySelectorAll('[data-gallery-target]').forEach(button => button.setAttribute('aria-current', String(button.dataset.galleryTarget === chosen.dataset.mediaId)));
        if (chosen.querySelector('img')) chosen.querySelector('img').loading = 'eager';
      }
      const thumbnails = section.querySelector('[data-gallery-thumbnails]');
      if (thumbnails && mediaNodes.length > 1) thumbnails.hidden = false;
      thumbnails?.addEventListener('click', event => { const button = event.target.closest('[data-gallery-target]'); if (button) activateMedia(button.dataset.galleryTarget); });
      function updateVariant(initial = false) {
        const values = groups.length ? groups.map(group => group.querySelector('select')?.value ?? group.querySelector('input:checked')?.value ?? '') : null;
        const variant = values ? state.exact(variants, values) : variants.find(entry => String(entry.id) === selector.value);
        const button = form.querySelector('.product-submit');
        const label = button.querySelector('[data-add-label]');
        const error = form.querySelector('.form-error');
        if (error && !initial?.detail?.keepError) error.textContent = '';
        if (values) values.forEach((value, index) => { const selected = section.querySelector(`[data-selected-option="${index}"]`); if (selected) selected.textContent = value; });
        if (values) groups.forEach((group,index) => {
          group.querySelectorAll('select option').forEach(option => {
            const available = state.available(variants,values,index,option.value);
            option.disabled = !available;
            const original = option.dataset.originalLabel || option.value;
            option.textContent = available ? original : `${original} — ${strings.sold}`;
          });
          group.querySelectorAll('.color-choice').forEach(choice => {
            const input = choice.querySelector('input');
            // A color remains in stock if any of its sizes are available.
            const colorOnlyValues = values.map((value,position) => colorIndexes.includes(position) ? value : '');
            const available = state.available(variants,colorOnlyValues,index,input.value);
            choice.classList.toggle('is-sold',!available);
            choice.title = available ? input.value : `${input.value} — ${strings.sold}`;
          });
        });
        button.disabled = !variant?.available;
        label.textContent = !variant ? strings.unavailable : variant.available ? strings.add : strings.sold;
        selector.value = variant ? String(variant.id) : '';
        // Color imagery resolves separately, even if the chosen size has no purchasable combination.
        const mediaId = values ? state.mediaFor(variants,values,colorIndexes) : variant?.featured_media?.id;
        activateMedia(mediaId ?? defaultMediaId);
        if (!variant) {
          section.querySelector('[data-product-price]').textContent = strings.unavailable;
          if (initial !== true) { const url = new URL(window.location.href); url.searchParams.delete('variant'); window.history.replaceState({}, '', url); }
          selector.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        const price = section.querySelector('[data-product-price]');
        price.textContent = money(variant.price);
        if (variant.compare_at_price > variant.price) { const comparison = document.createElement('s'); comparison.textContent = money(variant.compare_at_price); price.append(' ', comparison); const saved = state.discount(variant.price, variant.compare_at_price); if (saved > 0) { const badge = document.createElement('span'); badge.className = 'sale-badge'; badge.textContent = config.discountLabel.replace('__percent__', saved); price.append(' ', badge); } }
        const quantity = form.querySelector('[name="quantity"]');
        const rule = variant.quantity_rule || { min: 1, increment: 1 };
        quantity.min = rule.min; quantity.step = rule.increment;
        if (rule.max) quantity.max = rule.max; else quantity.removeAttribute('max');
        const currentQuantity = Number(quantity.value);
        if (currentQuantity < rule.min || (rule.max && currentQuantity > rule.max) || (currentQuantity - rule.min) % rule.increment !== 0) quantity.value = rule.min;
        if (initial !== true) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url); }
        selector.dispatchEvent(new Event('change', { bubbles: true }));
      }
      options?.addEventListener('change', updateVariant);
      section.addEventListener('atelier:variant-refresh', updateVariant);
      updateVariant(true);
    });
  }
  function initializeRecommendations(scope = document) {
    scope.querySelectorAll('[data-recommendations]').forEach(async section => {
      if (section.dataset.loaded) return;
      section.dataset.loaded = 'true';
      try { const response = await fetch(section.dataset.recommendations); if (!response.ok) return; const markup = new DOMParser().parseFromString(await response.text(), 'text/html'); const fresh = markup.querySelector('[data-recommendations]'); if (fresh && !fresh.hidden && fresh.querySelector('.product-card')) { section.innerHTML = fresh.innerHTML; section.hidden = false; globalThis.PVZODCatalogCards?.initialize(section); } } catch (_) {}
    });
  }
  initializeProducts(); initializeRecommendations();
  if (document.body.classList.contains('motion-enabled') && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold: 0.05 });
    document.querySelectorAll('.section-heading,.manifesto h2,.collection-tile').forEach(node => { node.classList.add('reveal-item'); observer.observe(node); });
    document.body.classList.add('reveal-ready');
  }
  document.addEventListener('shopify:section:load', event => { initializeProducts(event.target); initializeRecommendations(event.target); event.target.querySelectorAll('dialog').forEach(wireDialog); });
})();
